import { commitToStores } from "./executors/commitToStores";
import { loadSystemData } from "./executors/loadSystemData";
import { loadUserData } from "./executors/loadUserData";
import type { BootstrapStep } from "./types";

/** Шаги bootstrap для mobile (user + system data). */
export const bootstrapSteps: BootstrapStep[] = [
    {
        id: "loadUserData",
        label: "Загрузка данных пользователя",
        execute: loadUserData,
    },
    {
        id: "loadSystemData",
        label: "Загрузка системных данных",
        execute: loadSystemData,
    },
    {
        id: "commitToStores",
        label: "Подготовка сессии",
        execute: async (ctx) => {
            commitToStores(ctx);
        },
    },
];
